import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import { ListItemButton } from "@mui/material";
import Divider from "@mui/material/Divider";
import DescriptionIcon from "@mui/icons-material/Description";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import WorkIcon from "@mui/icons-material/Work";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function ProfileList(props) {
    return (
        <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
            <List component="nav">
                <ListItem>
                    <ListItemButton component="a" href="/">
                        <Typography variant="h6">{props.name}</Typography>
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton component="a" href="#/projects" data-testid="project-link">
                        <ListItemIcon><WorkIcon /></ListItemIcon>
                        <ListItemText primary="Projects" />
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton component="a" href="#/resume" data-testid="resume-link">
                        <ListItemIcon><DescriptionIcon /></ListItemIcon>
                        <ListItemText primary="Resume" />
                    </ListItemButton>
                </ListItem>
            </List>
            <Divider />
            <List component="nav">
                <ListItem>
                    <ListItemButton component="a" href="https://linkedin.com/in/davidjadkins">
                        <ListItemIcon><LinkedInIcon /></ListItemIcon>
                        <ListItemText primary="davidjadkins" />
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton component="a" href="https://facebook.com/DavidJAdkins">
                        <ListItemIcon><FacebookIcon /></ListItemIcon>
                        <ListItemText primary="DavidJAdkins" />
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton component="a" href="https://github.com/dadkins20">
                        <ListItemIcon><GitHubIcon /></ListItemIcon>
                        <ListItemText primary="dadkins20" />
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton component="a" href="https://twitter.com/davidadkins">
                        <ListItemIcon><TwitterIcon /></ListItemIcon>
                        <ListItemText primary="davidadkins" />
                    </ListItemButton>
                </ListItem>
                <ListItem>
                    <ListItemButton component="a" href="https://instagram.com/adventuresofdavid">
                        <ListItemIcon><InstagramIcon /></ListItemIcon>
                        <ListItemText primary="adventuresofdavid" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );
}
